module.exports = __webpack_public_path__ + "static/media/PM54.0205fd76.JPG";